<template>
  <div>
    <applicability-window
      :part-number="applicabilityWin.partNumber"
      :show="applicabilityWin.isVisible"
      @hide="applicabilityWin.isVisible = false"
    ></applicability-window>
    <v-data-table
      dense
      hide-default-footer
      :headers="[
        { text: this.$t('common.part'), value: 'brand', class: 'text-no-wrap' },
        { text: this.$t('common.title'), value: 'name', class: 'text-no-wrap' },
        {
          text: this.$t('common.supplier_name'),
          value: 'supplier_name',
          class: 'text-no-wrap',
        },
        {
          text: this.$t('common.delivery_time'),
          value: 'delivery_time',
          align: 'right',
          class: 'text-no-wrap',
        },
        {
          text: this.$t('common.amount'),
          value: 'amount',
          align: 'right',
          class: 'text-no-wrap text-center',
        },
        {
          text: this.$t('common.purchase_price'),
          value: 'purchase_price',
          align: 'right',
          class: 'text-no-wrap',
        },
        {
          text: this.$t('common.price'),
          value: 'price',
          align: 'right',
          class: 'text-no-wrap',
        },
        {
          text: this.$t('common.status'),
          sortable: false,
          class: 'text-no-wrap',
        },
      ]"
      :items="items"
      class="ma-0 orderpartttable rounded-0"
      :class="{
        grey: $vuetify.theme.light,
        'lighten-5': $vuetify.theme.light,
      }"
    >
      <template v-slot:body.append="props">
        <tr class="text-xs-left">
          <td colspan="4"></td>
          <td class="text-sm-center">
            <strong>{{
              Object.values(props.items).reduce(
                (sum, item) => item.amount + sum,
                0
              )
            }}</strong>
          </td>
          <td class="text-sm-right text-no-wrap">
            <strong>{{
                formatCurrency(Object.values(props.items)
                .reduce(
                  (sum, item) => item.purchase_price * item.amount + sum,
                  0
                )
                .toFixed(2))
            }} </strong>
          </td>
          <td class="text-sm-right text-no-wrap">
            <strong>{{
                formatCurrency(Object.values(props.items)
                .reduce((sum, item) => item.price * item.amount + sum, 0)
                .toFixed(2))
            }}</strong>
          </td>
          <td class="text-sm-right"></td>
        </tr>
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">
            <span
              class="text-no-wrap d-block"
              :style="getStyleApplicable(props.item.order_check_result)"
              :title="getTextApplicable(props.item.order_check_result)"
            >
              <v-progress-circular
                size="12"
                class="mr-1"
                width="2"
                indeterminate
                color="primary"
                v-if="
                  order.order_check_status !== 'ready' && order.order_check_id
                "
              />
              <v-btn
                class="d-inline-block"
                text
                fab
                x-small
                rounded
                inlist=""
                max-width="16"
                max-height="18"
                :title="$t('applicabilityWindow.applicability')"
                @click="
                  applicabilityWin.partNumber =
                    props.item.crossed_from_part_number ||
                    props.item.part_number;
                  applicabilityWin.isVisible = true;
                "
              >
                <v-icon x-small>$applicability</v-icon>
              </v-btn>
              <input
                v-show="false"
                :ref="'uploadImage' + props.item.id"
                type="file"
                @change="uploadImage(props.item)"
                accept="image/gif, image/jpeg, image/png"
              />
              <v-icon
                @click="$refs['uploadImage' + props.item.id].click()"
                :loading="imageLoading"
                :disabled="imageLoading"
                v-if="!props.item.image"
                x-small
                class="pointer"
              >
                fa-camera
              </v-icon>
              <v-icon
                v-else
                @click="showImage(props.item)"
                color="primary"
                x-small
                class="pointer"
              >
                $picture
              </v-icon>
              {{ props.item.brand }} {{ props.item.part_number }}
            </span>
            <span
              class="text-caption mb-0"
              v-if="
                props.item.crossed_from_brand &&
                props.item.part_number !==
                  props.item.crossed_from_part_number &&
                props.item.brand != props.item.crossed_from_brand
              "
            >
              <span class="text-no-wrap d-inline-block">{{
                $t("viewOrdersForm.crossed_from")
              }}</span>
              <span class="text-no-wrap">{{
                props.item.crossed_from_brand.toLocaleUpperCase() +
                " " +
                props.item.crossed_from_part_number
              }}</span>
            </span>
          </td>

          <td class="text-xs-left">
            <span v-if="props.item.name.length < 20">{{
              props.item.name
            }}</span>
            <span :title="props.item.name" v-else>{{
              props.item.name.substring(0, 20) + "..."
            }}</span>
          </td>

          <td class="text-xs-left">
            <a @click="changeSuplier(props.item)">{{
              props.item.supplier_name
            }}</a>
          </td>
          <td class="text-sm-right">{{ props.item.delivery_time }}</td>
          <td class="text-center">
            <v-container class="justify-center d-flex" style="width: 100px">
              <v-row class="mx-0" justify="center" no-gutters>
                <v-col class="pa-0">
                  <v-btn
                    max-width="17"
                    max-height="17"
                    outlined
                    color="pink darken-1"
                    fab
                    x-small
                    :disabled="savingInProgress || !fetched"
                    @click="
                      () => {
                        props.item.amount--;
                        submit();
                      }
                    "
                    >-
                  </v-btn>
                </v-col>
                <v-col class="pa-0">
                  <edit-value-menu
                      :item="props.item"
                      :field-name="'amount'"
                      @update="(item)=>{props.item.amount = item.amount; submit();}"
                      :disabled=" ! (props.item.nomenclature &&
                          props.item.nomenclature.unit_of_measurement &&
                          props.item.nomenclature.unit_of_measurement.is_divisible &&
                          props.item.nomenclature.unit_of_measurement.is_divisible === 1)  || !isEnabledStorageV2"
                  />
                </v-col>
                <v-col class="pa-0">
                  <v-btn
                    max-width="17"
                    max-height="17"
                    outlined
                    color="success"
                    depressed
                    fab
                    x-small
                    :disabled="savingInProgress || !fetched"
                    @click="
                      props.item.amount++;
                      submit();
                    "
                    >+
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </td>
          <td class="text-sm-right">
            <v-menu
              v-model="purchasePriceMenu[props.item.id]"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
            >
              <template v-slot:activator="{ on }">
                <a v-on="on" @click="priceTmp = props.item.purchase_price" class="text-no-wrap">
                  {{ formatCurrency(props.item.purchase_price) }}

                </a>
              </template>

              <v-card>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field
                        :placeholder="$t('common.purchase_price')"
                        v-model="priceTmp"
                        required
                        type="numeric"
                        :rules="[
                          (v) =>
                            !!v ||
                            $t('form.validationErrors.field_is_required'),
                        ]"
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    @click="purchasePriceMenu[props.item.id] = false"
                    >{{ $t("common.cancel") }}</v-btn
                  >
                  <v-btn
                    color="primary"
                    text
                    @click="
                      purchasePriceMenu[props.item.id] = false;
                      props.item.purchase_price = priceTmp;
                      submit();
                    "
                  >
                    {{ $t("common.save") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </td>
          <td class="text-sm-right">
            <v-menu
              v-model="priceMenu[props.item.id]"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
            >
              <template v-slot:activator="{ on }">
                <a v-on="on" @click="priceTmp = props.item.price" class="text-no-wrap">
                  {{ formatCurrency(props.item.price) }}
                </a>
              </template>

              <v-card>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field
                        :placeholder="$t('common.price')"
                        v-model="priceTmp"
                        required
                        type="numeric"
                        :rules="[
                          (v) =>
                            !!v ||
                            $t('form.validationErrors.field_is_required'),
                        ]"
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn text @click="priceMenu[props.item.id] = false">{{
                    $t("common.cancel")
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="
                      priceMenu[props.item.id] = false;
                      props.item.price = priceTmp;
                      submit();
                    "
                  >
                    {{ $t("common.save") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </td>

          <td class="text-xs-left" style="width: 150px">
            <v-select
              outlined
              :full-width="true"
              :id="'it_' + props.item.id"
              :items="order_parts_statuses"
              :label="$t('common.status')"
              item-text="name"
              return-object
              hide-details
              dense
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              v-model="props.item.status"
              @input="submit"
            >
              <template v-slot:selection="{ item }">
                <span class="text-no-wrap">
                  <span
                    :style="{
                      borderRadius: '14px',
                      width: '14px',
                      height: '15px',
                      background: item.color,
                      color: getCorrectTextColor(item.color),
                    }"
                    class="pa-1 d-inline-block mr-1"
                  ></span>
                  {{
                    item.type === "system_order_part_status"
                      ? $t("common.orderPartsSystemStatusNames." + item.name)
                      : item.name
                  }}
                </span>
              </template>
              <template
                v-slot:item="{ item }"
                :style="{
                  background: item.color,
                  color: getCorrectTextColor(item.color),
                }"
              >
                <span
                  :style="{
                    borderRadius: '15px',
                    width: '15px',
                    height: '15px',
                    background: item.color,
                    color: getCorrectTextColor(item.color),
                  }"
                  class="pa-1 d-block mr-2"
                ></span>
                {{
                  item.type === "system_order_part_status"
                    ? $t("common.orderPartsSystemStatusNames." + item.name)
                    : item.name
                }}
              </template>
            </v-select>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <supplier-selector-window
      :types="['suppliers']"
      :supplier="
        orderPartForChangeSuplier && orderPartForChangeSuplier.supplier
      "
      @select="
        (data) => {
          orderPartForChangeSuplier.supplier_name = data.name;
          orderPartForChangeSuplier.supplier_id = data.id;
          submit()
        }
      "
      :is-visible="supplierChangeWindow"
      @hide="supplierChangeWindow = false"
    ></supplier-selector-window>
    <v-dialog v-model="showPartImage" max-width="600">
      <v-card class="pa-3">
        <v-card-text class="pa-0">
          <img
            class="partImage"
            :src="backendURL+'/levam/' + partImage"
          />
        </v-card-text>
        <v-divider class="my-2 mb-3"></v-divider>
        <v-card-actions class="ma-0 pa-0">
          <v-btn
            color="red"
            class="mr-1 white--text"
            elevation="0"
            @click="showPartImage = false"
          >
            {{ $t("common.close") }}
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            :loading="imageLoading"
            :disabled="imageLoading"
            @click="
              $refs['uploadImage' + showPartImageId].click();
              showPartImage = false;
            "
          >
            <v-icon small left>fa-camera</v-icon>
            {{ $t("common.replace") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import ApplicabilityWindow from "@/components/common/ApplicabilityWindow";
import SupplierSelectorWindow from "@/components/common/SupplierSelectorWindow";
import {mapState} from "vuex";
import EditValueMenu from "@/components/common/EditValueMenu.vue";

export default {
  name: "OrderFormPartsTable",
  components: {EditValueMenu, SupplierSelectorWindow, ApplicabilityWindow },
  mixins: [CommonMixin],
  props: {
    data: Array,
    order: null,
    id: String,
    height: String,
    showFooter: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    partImage: null,
    orderPartForChangeSuplier: null,
    supplierChangeWindow: false,
    showPartImage: false,
    purchasePriceMenu: {},
    priceMenu: {},
    priceTmp: null,
    /**
     * Used to set parameters of ApplicabilityWindow.
     */
    applicabilityWin: {
      partNumber: null,
      isVisible: false,
    },
  }),
  computed: {
    ...mapFields("orders", [
      "imageLoading",
      "comment",
      "fetched",
      "savingInProgress",
    ]),
    ...mapFields("statuses", ["order_statuses", "order_parts_statuses"]),
    items() {
      return this.data;
    },
    isEnabledStorageV2(){
      return process.env.VUE_APP_IS_ENABLED_STORAGE_V2 && process.env.VUE_APP_IS_ENABLED_STORAGE_V2.toLowerCase()==='true'
    },
  },
  methods: {
    getStyleApplicable(val) {
      let res = JSON.parse(val);
      if (!res || !this.order.order_check_status) return "";
      if (res.applicable === true) {
        return { color: "green" };
      }
      if (res.applicable === false) {
        return { color: "red" };
      }
    },
    getTextApplicable(val) {
      let res = JSON.parse(val);
      if (!res || !this.order.order_check_status) return "";
      if (res.applicable === true) {
        return this.$t("viewOrdersForm.check_result_true");
      }
      if (res.applicable === false) {
        return this.$t("viewOrdersForm.check_result_false");
      }
    },
    changeSuplier(item) {
      this.supplierChangeWindow = true;
      this.orderPartForChangeSuplier = item;
    },
    submit() {
      this.$emit('update');
      // this.$store
      //   .dispatch("orders/ordersUpdate", { id: this.order.id })
      //   .then((res) => {
      //     if (!res)
      //       this.$store.dispatch("orders/orderShow", { id: this.order.id });
      //   });
    },
    orderCheckResult() {
      if (!this.order) return;
      this.$store
        .dispatch("orders/orderCheckResult", { id: this.order.id })
        .then((data) => {
          if (!data.ready || data.ready !== true) {
          } else {

            this.$emit('refresh');
            //this.$store.dispatch("orders/orderShow", { id: this.order.id });
          }
        });
    },
    orderCheck() {
      this.$store
        .dispatch("orders/orderCheck", { id: this.order.id })
        .then((data) => {
          if (data.status === "success")
            this.order.order_check_id = data.task_id;
        });
      this.$emit('refresh');
      //this.$store.dispatch("orders/orderShow", { id: this.order.id });
    },
    showImage(image) {
      this.partImage = image.image;
      this.showPartImage = image.image;
      this.showPartImageId = image.id;
    },
    uploadImage(item) {
      this.$store
        .dispatch("orders/uploadImage", {
          file: this.$refs["uploadImage" + item.id].files[0],
          id: item.id,
        })
        .then((response) => {
          if (response.data.status === "success") {
            item.image = response.data.image;
            this.$inform(this.$t("common.operation_success"));
          }
        })
        .finally(() => {
          if (this.$refs["uploadImage" + item.id])
            this.$refs["uploadImage" + item.id].value = "";
        });
    },
  },
};
</script>

<style lang="scss">
.partImage {
  max-width: 100%;
}

.theme--light {
  .orderpartttable {
    thead {
      tr {
        th {
          background: #fafafc;
        }
      }
    }

    tbody {
      tr {
        td {
          background: #fafafc;
        }
      }
    }

    tbody {
      background: transparent;
    }
  }
}
</style>
